import React from "react";
import { blogCreators } from "../../data";
import { Link } from "react-router-dom";

export default function BlogCardCreadores() {

  return (
    <>
      <section className="our-blog-section pt-100 gray-light-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="section-heading mb-5">
                <h2>Creador: explora las funciones de nuestra App</h2>
                <p>
                  Conoce a fondo los usos de la aplicacion y disfrutala al maximo
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {blogCreators.map((data) => (
              <div className="col-md-4">
                <div className="single-blog-card card border-0 shadow-sm">
                  <span className="category position-absolute badge badge-pill badge-primary">
                    {data.category}
                  </span>
                  <Link to={`/${data.route}`}>
                  <img
                    src={data.thumbnail}
                    className="card-img-top position-relative"
                    alt="blog"
                  />
                  </Link>
                  <div className="card-body">
                    <div className="post-meta mb-2">
                      <ul className="list-inline meta-list">
                        <li className="list-inline-item">{data.date}</li>
                        <li className="list-inline-item">
                          <span>{data.comments}</span> Comments
                        </li>
                        <li className="list-inline-item">
                          <span>{data.share}</span> Share
                        </li>
                      </ul>
                    </div>
                    <h3 className="h5 card-title">
                      <Link to={`/${data.route}`}>{data.title}</Link>
                    </h3>
                    <p className="card-text">{data.excerpt} </p>
                    <Link to={`/${data.route}`} className="detail-link">
                      Conocer Mas <span className="ti-arrow-right"></span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
